import {TextField} from '@mui/material'
import {DatePicker as MUIDatePicker, LocalizationProvider} from '@mui/x-date-pickers'
import React from 'react'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {MobileDateTimePicker} from "@mui/x-date-pickers/MobileDateTimePicker";
import moment from "moment";

const DatePickerInlineLabel = ({label, value, onChange, onBlur, disabled, error, helperText, hasHour}) => {
    return (
        !hasHour ? <LocalizationProvider dateAdapter={AdapterDayjs} sx={error && {border: '1px solid #d32f2f'}}>
                <MUIDatePicker
                    value={value}
                    format={'YYYY-MM-DD'}
                    inputFormat="DD/MM/YYYY"
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    sx={error && {border: '1px solid #d32f2f'}}
                    componentsProps={{
                        actionBar: {actions: ['clear', 'today']},
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            label={label}
                            fullWidth
                            error={error}
                            helperText={helperText}
                            style={disabled ? {color: '#f00', backgroundColor: 'hsl(0, 0%, 95%)'} : {}}
                        />
                    )}
                />
            </LocalizationProvider> :
            <LocalizationProvider dateAdapter={AdapterDayjs} sx={error && {border: '1px solid #d32f2f'}}>
                <MobileDateTimePicker
                    label={label}
                    value={value}
                    componentsProps={{
                        actionBar: {actions: ['clear', 'today']},
                    }}
                    disabled={disabled}
                    ampm={false}
                    inputFormat="DD/MM/YYYY HH:mm"
                    onChange={e => {
                        onChange(moment(new Date(e)).format('YYYY-MM-DDTHH:mm:ss'))
                    }}
                    renderInput={(params) => (
                        <>
                            <TextField
                                {...params}
                                size="small"
                                error={error}
                                disabled={disabled}
                                fullWidth
                                label={label}
                                helperText={helperText}
                                style={disabled ? {color: '#f00', backgroundColor: 'hsl(0, 0%, 95%)'} : {}}
                            />
                        </>
                    )}
                />
            </LocalizationProvider>

    )
}

export default DatePickerInlineLabel
